<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import obirim from "@/models/obirim";
export default {
  mixins: [Api, Sabit, obirim],
  page: {
    title: "Birimler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    addedit,
  },
  data() {
    return {
      title: "Birimler",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        }, 
        {
          text: "Birimler",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      SadeceKurumlar: true,
      Filter: {
        Birimadi: "",
        Temsilci: "",
        Birimtip: 2,
      },
    };
  },

  methods: {
    SadeceKurumlarDegisti() {
      this.Filter.Birimtip = this.SadeceKurumlar ? 2 : null;
      this.Page.PageNumber = 1;
      this.Get();
    },
    Get() {


      var FilterText = "&Asc=Birimkodu"

      if (this.Filter.Birimadi != null && this.Filter.Birimadi != ""  &&
      typeof this.Filter.Birimadi === "string" && this.Filter.Birimadi.length > 2) {
        FilterText += "&Birimadi=" + this.Filter.Birimadi
      }

      if (this.Filter.Temsilci != null && this.Filter.Temsilci != "" &&
      typeof this.Filter.Temsilci === "string" && this.Filter.Temsilci.length > 2) {
        FilterText += "&Temsilci=" + this.Filter.Temsilci
      }

      if (this.Filter.Birimtip != null && this.Filter.Birimtip != "") {
        FilterText += "&Birimtip=" + this.Filter.Birimtip
      }

      this.ActionsFilterGet({
        Service: "obirim",
        Page: this.Page,
        Filter:  FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <div class="col-sm-12">
                  <b-form-checkbox v-model="SadeceKurumlar" @change="SadeceKurumlarDegisti">
                    Sadece Kurumlar
                  </b-form-checkbox>
                </div>

                <div class="col-sm-8 row">

                        <b-form-group class="col-lg-3" label="Birim Adı"  >
                            <b-form-input  v-model="Filter.Birimadi"   type="text"  ></b-form-input>
                            </b-form-group>

                        <b-form-group class="col-lg-3" label="Temsilci Adı"  >
                            <b-form-input  v-model="Filter.Temsilci"   type="text"  ></b-form-input>
                            </b-form-group>

                        <div class="col-lg-3 mt-4">
                          <button class="btn btn-success  " data-bs-dismiss="offcanvas" type="button"
                            data-bs-target="#demo" @click="Page.PageNumber = 1, Get()">
                            Filtreleme
                          </button>
                          </div>

                </div>
                <div class="col-sm-4">
                  <div class="text-sm-end">

                    
                  <button
                    type="button"
                    class="btn btn-primary btn-rounded mb-2 me-2"
                    v-b-modal.obirim
                    @click="(DataUpdate = obirimData), (AddEdit = 'Add')"
                  >
                    <i class="mdi mdi-plus me-1"></i>
                    Yeni Kayıt Ekle
                  </button>

                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Birim Kodu</th>
                      <th>Birim Adı</th>
                      <th>Temsilci</th>
                      <th v-if="APPLICATION_TYPE == '1'">Uygulamalar</th>
                      <th v-if="APPLICATION_TYPE == '3'">Amirler</th>
                      <th>Telefon</th>
                      <th>E-Posta</th>
                      <th>Adres</th> 
                      <th class="text-center">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birimkodu }}</th>
                      <td>{{ Data.Birimadi }}</td>
                      <td>{{ Data.Temsilci }}</td>
                      <td v-if="APPLICATION_TYPE == '1'">{{ Data.Uygulamalar }}</td>
                      <td v-if="APPLICATION_TYPE == '3'">{{ Data.Amirler }}</td> 
                      <td>{{ Data.Telefon }}</td> 
                      <td>{{ Data.Eposta }}</td> 
                      <td>{{ Data.Adres }}</td>  
                      <td>
                        <div
                          class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <b-button-group>
                            <b-button
                              v-b-tooltip.hover
                              title="Düzenle"
                              variant="success"
                              v-b-modal.obirim
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                              ><i class="far fa-edit"></i
                            ></b-button>
                            <b-button
                              variant="danger"
                              v-b-tooltip.hover
                              title="Sil"
                              @click="Delete('obirim', Data.Id)"
                              ><i class="far fa-trash-alt"></i
                            ></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
